import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import Feed, { Props as FeedWidgetProps } from './Feed';
import reduxConnectContainer from './Feed.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import ConfigPopover from '../_partials/ConfigPopover';
import EmptyState from '../../EmptyState';

import s from './FeedBox.scss';

export interface Props {
  isOwner: boolean;
  openSubmitPostPopup: () => void;
}

const FeedConfigForm = lazy(() =>
  import(/* webpackChunkName: "owner" */ './FeedConfigForm')
);

class FeedBox extends React.Component<
  Props &
    FeedWidgetProps &
    WidgetBoxProps &
    WithTranslation &
    WithVerificationProps
> {
  render() {
    const {
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      isEmpty,
      isOwner,
      openSubmitPostPopup,
      isVerificationNeeded,
      pushVerificationPopup,
      t,
      section,
      zone,
      ...props
    } = this.props;

    return (
      <WidgetBox
        moduleId={props.moduleId}
        section={section}
        zone={zone}
        header={this.props.t!('widgets.feed.header')}
        seeAllUrl={Url.userLink(
          props.profileOwnerUser.username,
          `${USER_PROFILE_SECTION_PATHS.POSTS}`
        )}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        widgetMenuRenderer={closeMenu => (
          <ConfigPopover width={266} onClose={closeMenu} withPaddings={false}>
            <Suspense fallback={<ChunkLoadingPopover />}>
              <FeedConfigForm moduleId={props.moduleId} onClose={closeMenu} />
            </Suspense>
          </ConfigPopover>
        )}
        isEmpty={isEmpty}
        emptyView={
          isOwner ? (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={t!('widgets.feed.empty.title.owner')}
              subtitle={t!('widgets.feed.empty.subtitle.owner')}
              buttonLabel={t!('widgets.feed.empty.CTALabel.owner')}
              withButton
              onButtonClick={
                isVerificationNeeded
                  ? () => pushVerificationPopup('submitstatus')
                  : openSubmitPostPopup
              }
            />
          ) : (
            <EmptyState
              view="small"
              className={s['empty-state']}
              title={t!('widgets.feed.empty.title.visitor', {
                username: props.profileOwnerUser.username,
              })}
              subtitle={t!('widgets.feed.empty.subtitle.visitor', {
                username: props.profileOwnerUser.username,
              })}
            />
          )
        }
      >
        <Feed {...props} />
      </WidgetBox>
    );
  }
}

const enhance = compose(
  withVerification,
  reduxConnectContainer,
  withTranslation()
);

export default enhance(FeedBox);
